export const URL = process.env.GATSBY_URL;
export const API_URL = process.env.GATSBY_API_URL;
export const MESSENGER_APP_ID = '233023371810917';
export const MESSENGER_PAGE_ID = '1554240018237831';
export const GOOGLE_MAPS_KEY = process.env.GATSBY_MAPS_KEY;